export default "__VITE_ASSET__CTP2DP0s__"